import { OrganizationManagement } from "@/components/admin/OrganizationManagement";

export default function OrganizationsPage() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold">Organization Management</h2>
        <p className="text-muted-foreground">Manage organizations and their settings</p>
      </div>
      <OrganizationManagement />
    </div>
  );
}
